module.exports = __webpack_public_path__ + "img/qq.fec1b026.png";